import { useTranslation } from "@/hooks/useTranslation";
import OrdersAddDialog from "@/pages/orders/OrdersAddDialog/Index";
import { addOrderDialogAtom } from "@/store/order";
import { Button, Icon } from "@st-marketplace/ui";
import { useAtom, useSetAtom } from "jotai";
import type { FC } from "react";

export const AddOrderButton: FC = () => {
	const { t } = useTranslation();
	const openAddOrder = useSetAtom(addOrderDialogAtom);

	return (
		<Button
			type="button"
			color="primary"
			size="sm"
			startIcon={<Icon name="add-line" />}
			onClick={() => openAddOrder(true)}
		>
			{t("order.addButton")}
		</Button>
	);
};

/** Mounted once per dashboard; the heavy dialog only loads once it is opened. */
export const AddOrderDialogHost: FC = () => {
	const [open, setOpen] = useAtom(addOrderDialogAtom);
	return open ? <OrdersAddDialog open onClose={() => setOpen(false)} /> : null;
};
